import { default as isNudgedRow } from './isNudgedRow';
import { MailRowDataPropertyGetter, TableView } from 'owa-mail-list-store';

export default function isUnpinnedNudgedRow(rowKey: string, tableView: TableView): boolean {
    return (
        isNudgedRow(rowKey, tableView.id) &&
        !MailRowDataPropertyGetter.getIsPinned(rowKey, tableView)
    );
}
